import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addGameGroup from "./components/addGameGroup";
export default {
  name: "gameGroup",
  mixins: [loadMoreList, packageData],
  components: {
    addGameGroup: addGameGroup
  },
  data: function data() {
    return {
      pagingReqFn: "gameGroupList",
      delIds: [],
      groupNameData: ''
    };
  },
  activated: function activated() {
    this.getcommonData(['gameGroupList']);
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'gameGroupDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    groupNameChange: function groupNameChange(e) {
      if (e) {
        var data = this.gameGroupList.find(function (i) {
          return i.id == e;
        });
        this.paramsData.group_name = data.group_name;
        this.paramsData.id = data.id;
      } else {
        this.paramsData.group_name = '';
        this.paramsData.id = '';
      }
    }
  }
};